const translations = {
    // Page titles and headers
    "systemSettings": "הגדרות מערכת",
    "permissionsGroups": "קבוצת הרשאות",
    "users": "משתמשים",
    "infrastructureData": "נתוני תשתיות",

    // Tab labels
    "permissionsGroupTab": "קבוצת הרשאות",
    "usersTab": "משתמשים",
    "infrastructureTab": "נתוני תשתיות",
    "productFamilyTab": "משפחות מוצר",
    "customersTab": "לקוחות",
    "generalTab": "כללי",

    // Buttons and actions
    "addRole": "הוסף תפקיד",
    "addUser": "הוסף משתמש",
    "edit": "עריכה",
    "delete": "מחק",
    "deleteRole": "מחק תפקיד",
    "deleteUser": "מחק משתמש",
    "cancel": "ביטול",

    // Table headers
    "role": "תפקיד",
    "name": "שם",
    "lastName": "שם משפחה",
    "email": "אימייל",
    "username": "שם משתמש",
    "roles": "תפקידים",
    "branches": "סניפים",

    // Pages and permissions
    "homePage": "דף בית",
    "tradeApproval": "שחרור השהיות סחר",
    "obligoException": "חריגת אובליגו",
    "checkInvoices": "בדיקת חשבוניות",
    "purchaseInvoices": "חשבוניות רכש",
    "salesPromotions": "קד\"מ ודוגמיות",
    "permissions": "תפקידים והרשאות",
    "timeLine": "לוגים",
    "eldanPrinter": "מדפסת תוויות",
    "chemoRecords": "רשומות כימו",
    "importManagement": "ניהול ייבוא",
    "emailTracking": "מעקב אימיילים",
    "researchMonitor": "מחקרים והזדמנויות אלדן",       
    "researchMonitorRole": "מנהל - מחקרים והזדמנויות אלדן",
    "fuelControl": "בקרת תדלוקים",
    "fuelControlRole": "תפקיד - בקרת תדלוקים",
    "dplStatistics": "DPL - דוחות סטטיסטיקה",
    "eldanAgent": "אלדן - סוכן תקלות",       
    "promotionsSystem": "מערכת מבצעים",
    "qrCodeDeviceMapping": "סריקת מכשירים",
    "tradeDelay": "השהיות סחר",
    "agentComplaints": "תלונות סוכן",
    "libertyMedicalPage": "Liberty Medical — חשבוניות",
    "hrcvMatching": "התאמת קורות חיים למשרות",
    "managersDashboardPage": "דשבורד מנהלים",
    "purchaseOrderManagementRole": "מעקב רכש - ניאופרם ישראל",
    "purchaseOrderManagementAdminRole": "מנהל מעקב רכש - ניאופרם ישראל",
    
    // Page field mappings
    "HomePage": "דף הבית",
    "AproveLinesPage": "שחרור השהיות סחר",
    "ObligoExceptionPage": "חריגת אובליגו",
    "ViewObligoData": "צפייה בנתוני אובליגו",
    "CheckInvoicesPage": "בדיקת חשבוניות",
    "PurchaseInvoicePage": "חשבוניות רכש",
    "Form161Page": "טופס 161",
    "SalesPromotionsPage": "קד\"מ ודוגמיות",
    "PermissionsPage": "תפקידים והרשאות",
    "TimeLinePage": "לוגים",
    "EldanPrinterPage": "מדפסת תוויות",
    "emailTrackingPage": "ניהול ייבוא",
    "emailTrackingPage": "מעקב אימיילים",
    "ResearchMonitorPage": "מחקרים והזדמנויות אלדן",
    "ResearchMonitorRole": "מנהל - מחקרים והזדמנויות אלדן",
    "FuelControlPage": "בקרת דלק",
    "FuelControlRole": "תפקיד - בקרת דלק",
    "DplStatisticsPage": "DPL - דוחות סטטיסטיקה",
    "EldanAgentPage": "אלדן - סוכן תקלות",       
    "PromotionsSystemPage": "מערכת מבצעים",
    "QrCodeDeviceMappingPage": "סריקת מכשירים",
    "TradeDelayPage": "השהיות סחר",
    "HRCVMatchingPage": "התאמת קורות חיים למשרות",
    "AgentComplaintsPage": "תלונות סוכן",
    "LibertyMedicalPage": "Liberty Medical — חשבוניות",
    "ManagersDashboardPage": "דשבורד מנהלים",
    "CustomerPortalPage": "פורטל לקוחות",
    "PurchaseOrderManagementPage": "ניאופרם ישראל - הזמנות רכש",

    // Sales promotions
    "orderCreator": "יוצר הזמנות",
    "orderApprover": "מאשר הזמנות",
    "branch": "סניף",
    "ordererCustomer": "לקוח מזמין",
    "intOrderType": "סוג הזמנה פנימי",
    "extOrderType": "סוג הזמנה חיצוני",
    "family": "משפחות מוצר",
    "receiveCustomer": "לקוחות מקבלים",

    // Obligo access levels
    "obligoAccessNone": "אין גישה",
    "obligoAccessReadonly": "צפייה בלבד",
    "obligoAccessFull": "גישה מלאה",

    // Messages
    "roleNotFound": "תפקיד לא נמצא",
    "permissionsUpdateSuccess": "הרשאות עודכנו בהצלחה",
    "permissionsUpdateError": "ארעה שגיאה בעדכון ההרשאות",
    "roleUpdateSuccess": "הרשאות התפקיד עודכנו בהצלחה",
    "roleUpdateError": "ארעה שגיאה בעדכון התפקיד",
    "deleteRoleConfirm": "אתה בטוח שברצונך למחוק תפקיד זה?",
    "roleDeleteSuccess": "התפקיד נמחק בהצלחה",
    "roleAddSuccess": "התפקיד נוסף בהצלחה",
    "duplicateRoleError": "קיים תפקיד בשם זהה",
    "deleteUserConfirm": "אתה בטוח שברצונך למחוק משתמש זה?",
    "userDeleteSuccess": "המשתמש נמחק בהצלחה",
    "userUpdateSuccess": "פרטי המשתמש עודכנו במערכת",
    "userAddSuccess": "המשתמש נוסף בהצלחה",
    "generalError": "ארעה שגיאה",
    "loading": "אנא המתן...",

    // Misc
    "noData": "לא הוגדרו נתונים",
    "noRoles": "No roles available",
    "selectMultipleBranches": "ניתן לבחור כמה סניפים",
    "andMore": "נוספים",
    "checkUserPermissions": "בדוק הרשאות משתמש",
    "somethingWentWrong": "משהו השתבש"
};

export default translations;